import { createFileRoute } from '@tanstack/react-router'

const GerminationPage = () => {
  return (
    <div className="mt-6 flex-col pb-6 sm:w-full">
      <h4 className="mb-2 text-xl font-bold text-gray-800">Seed Germination</h4>

      <p className="mb-2">
        Information on germination conditions is in the following format;
        germination temperature(s), light hours/dark hours (per 24 hour period).
        e.g. 21°C, 12/12 (seeds were incubated at 21°C with a 12 hour
        photoperiod). e.g. 21/11°C, 8/16 (in this case seeds were kept in the
        light for 8 hours at 21°C, and in the dark for 16 hours at 11°C per 24
        hour period).
      </p>

      <p className="mb-2">
        Depending on the protocol required, some fields may be empty. It is
        worth noting that the germination protocols described relate to
        controlled laboratory experiments. Translating this information to
        determine how to germinate seeds in the field subsequently requires
        care.
      </p>
    </div>
  )
}

export const Route = createFileRoute('/definitions/germination')({
  component: GerminationPage,
})
